import { render, staticRenderFns } from "./ActivityRuleConfig.vue?vue&type=template&id=2325dfe9&scoped=true&"
import script from "./ActivityRuleConfig.vue?vue&type=script&lang=js&"
export * from "./ActivityRuleConfig.vue?vue&type=script&lang=js&"
import style0 from "./ActivityRuleConfig.vue?vue&type=style&index=0&id=2325dfe9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2325dfe9",
  null
  
)

export default component.exports